import { action as apiAction } from 'api/Api'
import {
  setResponsible,
  addUser
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  userId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { id, userId } = payload

  const state = getState()

  const card = state['view-board'].cards[id]

  let optimisticAction
  if (card) {
    const currentResponsible = card.responsible
    const isUserInCard = card.users.indexOf(userId) !== -1
  
    if (!isUserInCard && currentResponsible !== userId) {
      if (currentResponsible) {
        optimisticAction = optimisticDispatch(dispatch, addUser({
          id,
          userId,
          index: undefined
        }))
      } else {
        optimisticAction = optimisticDispatch(dispatch, setResponsible({
          id,
          responsible: userId
        }))
      }
    }
  }

  try {
    await apiAction('AddUserToCard', {
      cardId: id,
      userId
    })
  } catch (error) {
    if (error.code !== 300) { // Duplicate
      throw error
    }
  } finally {
    if (optimisticAction) {
      optimisticAction.revert()
    }
  }
}
